import { render } from "./ReturnHistoryLog.vue?vue&type=template&id=3b0d9354"
import script from "./ReturnHistoryLog.vue?vue&type=script&lang=js"
export * from "./ReturnHistoryLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__